
<script>
export default {
  name: 'AgencyProfile',
  computed: {
    agencyProfile() {
      return this.$store.getters['profile/getAgencyProfile']
    },
  },
}
</script>

<template>
  <div class="my-agency__form-table">
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>Название</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.name }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>Полное название, форма</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.legalName }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>ИНН</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.inn }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>БИК</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.bik }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>КПП</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.kpp }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>Фактический адрес</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.address }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>Юридический адрес</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.legalAddress }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>Телефон</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.phone }}</p>
      </div>
    </div>
    <div class="my-agency__form-table-row">
      <div class="my-agency__form-table-label">
        <p>E-mail</p>
      </div>
      <div class="my-agency__form-table-content">
        <p>{{ agencyProfile.email }}</p>
      </div>
    </div>
  </div>
</template>